/**
 * Created by Shikha on 2021-04-22.
 */
import {TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {SoundManager} from "../resource/sound/SoundManager";

export class MayhemModeIntroView extends BaseView {
    private _layer: PIXI.Container;
    private _mayhemIntro: PIXI.spine.Spine;

    constructor() {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.MAYHEM_INTRO.name);
    }

    public playAnimation(triggeredWithInFS: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    this._mayhemIntro.visible = false;
                    this._mayhemIntro.state && this._mayhemIntro.state.clearTracks();
                }
            }),
            duration = this._mayhemIntro.spineData.findAnimation("desktop").duration;

        this._layer.addChild(this._mayhemIntro);
        this._mayhemIntro.updateTransform();
        this._mayhemIntro.visible = true;
        this._mayhemIntro.alpha = 1;
        this._mayhemIntro.state.setAnimation(0, "desktop", false);

        // #454
        SoundManager.playFSMayhemSplash();

        // #435
        if (triggeredWithInFS) {
            TweenLite.delayedCall(0.157, () => SoundManager.playSuperFreeSpinBGFromFS());
        }
        tl.add(() => {
            this._mayhemIntro.state.setAnimation(0, "desktopLoop", true);
        }, duration);
        tl.to(this._mayhemIntro, 0.2, {
            alpha: 0
        }, duration + 1);

        //#381 #297 additional sec
        tl.add(() => {
            HorribleHeroesGameModuleConfig.logoAnimations.showLogo("MAYHEM_MODE");
        });

        return tl;
    }

    protected initAnimations(): void {
        this._mayhemIntro = new PIXI.spine.Spine(GameResources.getSpineAsset("mayhemIntro"));
        this._mayhemIntro.position.set(360, 360);
    }

    protected onResize(resizeData: IResizeData): void {
        this._mayhemIntro.scale.set((resizeData.width < 1277) ? 0.8 : 1);
    }
}